export default "<div *ngIf=\"isLoading\" class=\"overlay\">\n  <div class=\"spinner\"></div>\n</div>\n";